import { useMemo } from 'react'
import { useGetOne } from 'react-admin'

const useGroupMembershipRecord = (resource, source, record, { enabled = true } = {}) => {
  const needsDetails = enabled && Boolean(record?.id) && !Array.isArray(record[source])
  const { data, isPending } = useGetOne(
    resource,
    { id: record?.id, meta: { membershipDetails: true } },
    { enabled: needsDetails, retry: false },
  )
  const membershipRecord = useMemo(
    () => (needsDetails && data ? { ...record, [source]: data[source] } : record),
    [data, needsDetails, record, source],
  )

  return { record: membershipRecord, isPending: needsDetails && isPending }
}

export default useGroupMembershipRecord
